/*
 * @Author: renjianshu
 * @Date: 2019-01-28 17:06:01
 * @LastEditors: gengming
 * @LastEditTime: 2020-06-30 10:40:52
 * @Description: file content
 */
// created by liujunyang 2016-07-18

// 解决低版本数组接口兼容等ES6
import "@babel/polyfill";

import 'style/style.scss'
import navData from 'nav-data'
import {resetNavbar, setSize, initProtocal,pagereload, getPlatformKey, loadScript} from 'utils'
import Vue from 'vue'

import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueFilter from 'vue-filter'
import VueHttp from 'vue-http'
import VueTouch from 'vue-touch'

import Cookies from 'js-cookie'
// 国际化
import VueI18n from 'vue-i18n'
import language from 'language/language'

import { Toast } from 'mint-ui';

//设置zepto CSRFToken
import zeptoHttp from 'zepto-http'

import template from 'layout/index.html'
import { isFlutterApp, callFlutter } from 'android.js'
// 日活上报
import dailyReport from 'daily-report'
// 埋点上报
import sensorsDataReport from 'sensors-report'

Vue.prototype.sensorsReport = sensorsDataReport

import vars from 'vars'
import setDocumentTitle from "./util/setDocumentTitle";

let sensors = null

if(navigator.userAgent.toLowerCase() && /flutterapp/i.test(navigator.userAgent.toLowerCase()) || window.__wxjs_environment === 'miniprogram'){
}else{
  sensors = require('sa-sdk-javascript');
  let hostname = window.location.hostname;
  let show_log = true
  if(/^(www.xuetangx.com|next.xuetangx.com|www.yuketang.cn)$/.test(hostname)){
    show_log = false
  }
  sensors.init({
    show_log: show_log,
    is_track_single_page: true,
    app_js_bridge: true,
    send_type: "beacon"
  });
}

window.sensors = sensors


Vue.config.debug = process.env.NODE_ENV !== 'production'
Vue.config.devtools = true
// process.env.NODE_ENV = 'production'
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VueFilter)
Vue.use(VueHttp)
Vue.use(VueTouch)
Vue.use(zeptoHttp)
Vue.use(VueI18n)

// 全局使用
window.Vue = Vue;
window.Toast = Toast

let key = getPlatformKey()
if(key === 'thu'){
    Vue.prototype.isThu = true
}else if(key === 'changjiang'){
    Vue.prototype.isChangjiang = true
}else if(key === 'huanghe'){
    Vue.prototype.isHuanghe = true
}else if(key === 'rain'){
    Vue.prototype.isRain = true
}else if(key === 'protest'){
    Vue.prototype.isPro = true
}else if(key === "g"){
  Vue.prototype.isG = true
}else if(key === "thunder"){
  Vue.prototype.isThunder = true
}else if(key === 'pre-apple-ykt'){
  Vue.prototype.isWind = true
}else if(key === 'gc') {
  Vue.prototype.isGC = true
}else if(key === 'yudou') {
  Vue.prototype.isYD = true
}else if(key === 'envning'){
  Vue.prototype.isEnvning = true
}else if(key === 'env-example') {
  Vue.prototype.isEnvExample = true
}
// 控制讨论区是是否开放
Vue.prototype.isDiscussionOpen = true

let lng = Cookies.get('django_language') || 'zh-cn';
lng = lng === 'zh-cn' ? 'zh_CN' : 'en';
// set language
language.setLanguage(lng);

setDocumentTitle()

let vueRouterConfig = {history: true,root:"/v/index"}

if (process.env.NODE_ENV !== 'production') {
    Vue.http.patch = Vue.http.get
    // Vue.http.post = Vue.http.get
    vueRouterConfig = {history: true, root: null}
}
//用于参数传递，在vue-http.js
Vue.config.vueRouterConfig = vueRouterConfig;

const router = new VueRouter(vueRouterConfig)

function launchIntoFullscreen(element) {
  if(element.requestFullscreen) {
    element.requestFullscreen();
  } else if(element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if(element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
}
function setHeaderStorageFn() {
    return new Promise((resolve, reject) => {
        if (typeof localStorage === 'object') {
            // 默认当前设备是 普通浏览器
            localStorage.setItem('x-client', 'web')
            // 小程序
            if(window.__wxjs_environment === 'miniprogram') {
                localStorage.setItem('x-client', 'miniprogram')
                resolve({})
                return
            }
            // 公众号
            var ua = navigator.userAgent.toLowerCase();
            if(ua.match(/MicroMessenger/i)=="micromessenger") {
                localStorage.setItem('x-client', 'wechat')

                resolve({})
                return
            }
            // flutter webview iframe嵌套会出现和客户端的交互问题，这个操作只适用webview 直接打开的页面
            if (isFlutterApp && window === window.top) {
                localStorage.setItem('x-client', 'apph5')
                window.callJS = function(res) {
                    let data = res
                    let type = typeof res
                    if (type === 'string') {
                        data = JSON.parse(res)
                    }
                    if (data.data) {
                        let info = data.data
                        if(typeof data.data === 'string') {
                            info = JSON.parse(data.data)
                        }
                        const sessionid = info.sessionid
                        const fluttertype = info.type
                        const version = info.version;
                        !!sessionid && localStorage.setItem('sessionid', sessionid)
                        !!fluttertype && localStorage.setItem('fluttertype', fluttertype)
                        !!version && localStorage.setItem('flutterversion', version)
                        resolve({sessionid})
                    } else {
                        reject(data)
                    }
                }
                callFlutter('getSession', {})
                // callFlutter('getAppType', {})
                // 不等待 flutter 调用window.callJS
                // resolve({sessionid: 0})
            } else {
                resolve({})
            }

        } else {
            resolve({})
        }
    })
}
var App = Vue.extend({
    data(){
        return {
        }
    },
    ready(){
        setTimeout(()=>{
            require(['mint-ui', 'mint-ui/lib/style.css'], function(MintUI){
                Vue.use(MintUI)
                Vue.use(MintUI.Lazyload)
                // 全局使用
                window.MintUI = MintUI;
            })
        }, 0)
        // iOS下微信配置一次
        if($.isIOS()) $.setWXConfig();
    },
    template: template
})

router.map({
    '/': {
        name: 'home',
        component: function (resolve) {
            require(['module/home/home.vue'], resolve)
        }
    },
    '/lessonend': {
        name: 'lessonend',
        component: function (resolve) {
            require(['module/course/normalcourse/student/lessonend.vue'], resolve)
        }
    },
    '/course': {
        name: 'course',
        component: function (resolve) {
            require(['module/course/course.vue'], resolve)
        },
        subRoutes: {
            '/normalcourse': {
                name: 'classroomcourse',
                component: function (resolve) {
                    require(['module/course/normalcourse/classroomcourse.vue'], resolve)
                },
                subRoutes:{
                    "/":{
                        name:"normalcourse",
                        component: function (resolve) {
                            require(['module/course/normalcourse/normalcourse.vue'], resolve)
                        }
                    },
                    '/error/:status_code':{
                        name: 'error',
                        component: function (resolve) {
                            require(['module/error/error.vue'], resolve)
                        }
                    },
                    "/new_course/0":{
                        name:"new_course",
                        component: function (resolve) {
                            require(['module/course/normalcourse/edit_course.vue'], resolve)
                        }
                    },
                    "/edit_course/:courseid":{
                        name:"edit_course",
                        component: function (resolve) {
                            require(['module/course/normalcourse/edit_course.vue'], resolve)
                        }
                    },
                    "/manage_classroom/:courseid/:classroomid":{
                        name:"manage_classroom",
                        component: function (resolve) {
                            // require(['module/course/normalcourse/manage_classroom.vue'], resolve)
                            require(['module/course/normalcourse/logs/logs.vue'], resolve)
                        }
                    },
                    "/manage_classroom_export/:courseid/:classroomid":{
                        name:"manage_classroom_export",
                        component: function (resolve) {
                            require(['module/course/normalcourse/logs/logs.vue'], resolve)
                        }
                    },
                    //不要再修改manage_classroom.vue（文件没有删除），使用manage_classroom_new.vue
                    "/manage_classroom_student/:courseid/:classroomid":{
                        name:"manage_classroom_student",
                        component: function (resolve) {
                            require(['module/course/normalcourse/manage_classroom_new.vue'], resolve)
                        }
                    },
                    //不要再修改manage_student.vue（文件没有删除），使用manage_student_new.vue
                    "/manage_student/:courseid/:classroomid":{
                        name:"manage_student",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/manage_student_new.vue'], resolve)
                        }
                    },
                    "/manage_auditor/:courseid/:classroomid":{
                        name:"manage_auditor",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/manage_auditor.vue'], resolve)
                        }
                    },
                    "/blacklist/:id": {
                        name: "blacklist",
                        component: function (resolve) {
                            require(['module/course/normalcourse/blacklist.vue'], resolve)
                        }
                    },
                    // new 新教学日志
                    "/logs/:courseid/:classroomid":{
                        name:"logs",
                        component: function (resolve) {
                            require(['module/course/normalcourse/logs/logs.vue'], resolve)
                        }
                    },

                    // 课程设置
                    "/set_course/:courseid/:classroomid":{
                        name:"set_course",
                        component: function (resolve) {
                            // require(['module/course/normalcourse/logs/set_course.vue'], resolve)
                            require(['module/course/normalcourse/logs/course-setting.vue'], resolve)
                        }
                    },
                    // 班级设置
                    "/set_classroom/:courseid/:classroomid":{
                        name:"set_classroom",
                        component: function (resolve) {
                            // require(['module/course/normalcourse/logs/set_classroom.vue'], resolve)
                            require(['module/course/normalcourse/logs/course-setting.vue'], resolve)
                        }
                    },
                    // 设置学生端开放功能
                    "set_class_config/:cid/:member/:forum/:group/:questions": {
                        name: 'set_class_config',
                        component: function(resolve){
                            require(['module/course/normalcourse/logs/config-setting.vue'], resolve)
                        }
                    },

                    // 教师预习详情
                    "/teaching_cards_detail/:courseware_id":{
                        name:"teaching_cards_detail",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher-cards-detail.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 教师预习完成情况
                    "/teaching_cards_completion/:cardid":{
                        name:"teaching_cards_completion",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher-cards-completion.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 单个学生的预习数据
                    "/teaching_cards_completion_detail/:cardid/:userid":{
                        name:"teaching_cards_completion_detail",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher-cards-completion-detail.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 教师预习查看课件
                    "/teaching_cards/:cardid":{
                        name:"teaching_cards",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/cards/cards.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 教师试卷完成情况
                    "/teaching_quiz_completion/:quizid":{
                        name:"teaching_quiz_completion",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher-quiz-completion.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 教师试卷完成情况 思博新版本（带排序搜索）
                    "/teaching_quiz_completion_sort/:quizid":{
                        name:"teaching_quiz_completion_sort",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher-quiz-completion-sort.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 教师试卷完成情况 思博新版本（学生详情卡片页）
                    "/teaching_quiz_completion_sort_detail/:quizid/:userid":{
                        name:"teaching_quiz_completion_sort_detail",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher-quiz-completion-sort-detail.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 教师预习批改
                    "/teaching_cards_correction/:cardid/:problemid": {
                        name:"teaching_cards_correction",
                        component: function (resolve) {
                            require(['pages/correction/correction.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 教师试卷批改
                    "/teaching_quiz_correction/:quizid/:problemid": {
                        name:"teaching_quiz_correction",
                        component: function (resolve) {
                            require(['pages/correction/correction.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 课程小结入口 start
                    "/teaching_lesson_detail/:courseware_id":{
                        name:"teaching_lesson_detail",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teaching_lesson_detail.vue'], resolve)
                        }
                    },
                    // 签到统计
                    "/teacher_sign_list/:id/:type":{
                        name:"teacher_sign_list",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher_sign_list.vue'], resolve)
                        }
                    },
                    // 课堂签到统计及学生得分情况
                    "/teacher_sign_list_lesson_summary/:lessonid":{
                        name:"teacher_sign_list_lesson_summary",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher_sign_list_lesson_summary.vue'], resolve)
                        }
                    },
                    "/teacher_tougao/:courseware_id":{
                        name:"teacher_look_tougao",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/look_tougao.vue'], resolve)
                        }
                    },
                    "/lesson_summary/rank/:courseware_id":{
                        name:"lesson_summary_rank",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/lessonsummary/rank.vue'], resolve)
                        }
                    },
                    "/lesson_summary/personal/:courseware_id/:user_id":{
                        name:"lesson_summary_personal",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/lessonsummary/personal.vue'], resolve)
                        }
                    },
                    "/lesson_summary/members/:courseware_id":{
                        name:"lesson_summary_members",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/lessonsummary/members.vue'], resolve)
                        }
                    },
                    // 课程小结入口 end
                    // 教师试卷详情
                    "/teacher_quiz_detail/:courseware_id":{
                        name: "teacher_quiz_detail",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher-quiz-detail.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 考试小结
                    "/exam/:eid/:cid":{
                        name: "exam_summary",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/exam/summary.vue'], resolve)
                        }
                    },
                    "/completion/:eid/:cid":{
                        name: "exam_completion",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/exam/exam-completion.vue'], resolve)
                        }
                    },
                    // 学生预习详情
                    "/learning_cards_detail/:courseware_id":{
                        name:"learning_cards_detail",
                        component: function (resolve) {
                            require(['module/course/normalcourse/student/learning-cards-detail.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 学生 主观题结果页
                    "/subjective_result/:problem_id": {
                        name:"subjective_result",
                        component: function (resolve) {
                            require(['pages/components/result.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    "/learning_lesson_detail/:courseware_id":{
                        name:"learning_lesson_detail",
                        component: function (resolve) {
                            require(['module/course/normalcourse/student/learning_lesson_detail.vue'], resolve)
                        }
                    },
                    "/learning_tougao/:courseware_id":{
                        name:"learning_tougao",
                        component: function (resolve) {
                            require(['module/course/normalcourse/student/look_tougao.vue'], resolve)
                        }
                    },
                    "/learning_lesson_score_detail/:courseware_id/:user_id":{
                        name:"learning_lesson_score_detail",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/lessonsummary/personal.vue'], resolve)
                        }
                    },
                    "/student_ppt_swipe/:type/:courseware_id/:index":{
                        name:"student_ppt_swipe",
                        component: function (resolve) {
                            require(['module/course/normalcourse/student/student_ppt_swipe.vue'], resolve)
                        }
                    },

                    "/student_ppt/:presentation_id":{
                        name:"student_ppt",
                        component: function (resolve) {
                            require(['module/course/normalcourse/student/student_PPT.vue'], resolve)
                        }
                    },
                    "/report_teacher/:cards_id":{
                        name:"report_teacher",
                        component: function (resolve) {
                            require(['module/course/normalcourse/student/report_teacher.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    "/cards_feedback_reply/:feed_back_id":{
                        name:"cards_feedback_reply",
                        component: function (resolve) {
                            require(['module/course/normalcourse/student/feedback_reply.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 教师客观题详情
                    "/teacher_cards_answer_detail/:problem_id/:item_count":{
                        name:"teacher_cards_answer_detail",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/cards-answer-detail.vue'], resolve)
                            // require(['module/course/normalcourse/teacher/teacher_cards_answer_detail.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 教师客观题详情 quiz
                    "/teacher_quiz_answer_detail/:problem_id/:item_count":{
                        name:"teacher_quiz_answer_detail",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/quiz-answer-detail.vue'], resolve)
                            // require(['module/course/normalcourse/teacher/teacher_quiz_answer_detail.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    "/show_teacherPPT/:presentation_id/:lesson_id":{
                        name:"show_teacherPPT",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher_PPT.vue'], resolve)
                        }
                    },
                    "/show_teacherslide_info/:lessonSlide_id/:currentIndex/:lessonid/:type/:presentation_id":{
                        name:"show_teacherslide_info",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher_PPT_one.vue'], resolve)
                        }
                    },
                    "/teacher_slideproblem_detail/:lessonSlide_id/:lessonid/:presentation_id":{
                        name:"teacher_slideproblem_detail",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher_slideproblem_detail.vue'], resolve)
                        }
                    },
                    "/teacher_lesson_subjective_problem_result_list/:lesson_id/:problem_id":{
                        name:"teacher_lesson_subjective_problem_result_list",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher_lesson_subjective_problem_result_list.vue'], resolve)
                        }
                    },
                    "/teacher_slideproblem_resultdetail/:lessonSlide_id":{
                        name:"teacher_slideproblem_resultdetail",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/teacher_slideproblem_resultdetail.vue'], resolve)
                        }
                    },
                    "/lesson_danmu_detail/:lesson_id":{
                        name:"lesson_danmu_detail",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/lesson_danmu_detail.vue'], resolve)
                        }
                    },
                    //不要再修改manage_role.vue（文件没有删除），使用manage_role_new.vue
                    "/manage_role/:classroom_id":{
                        name:"manage_role",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/manage_role_new.vue'], resolve)
                        }
                    },
                    //不要再修改manage_role_collaborator.vue（文件没有删除），使用manage_role_collaborator_new.vue
                    "/manage_role_collaborator/:classroom_id":{
                        name:"manage_role_collaborator",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/manage_role_collaborator_new.vue'], resolve)
                        }
                    },
                    "/advance_pub_courseware/:id":{
                        name:"advance_pub_courseware",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/pre_publish/pub.vue'], resolve)
                        }
                    },
                    "/advance_pub_success":{
                        name:"advance_pub_success",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/pre_publish/advance_pub_success.vue'], resolve)
                        }
                    },
                    "/advance_pub_failure":{
                        name:"advance_pub_failure",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/pre_publish/advance_pub_failure.vue'], resolve)
                        }
                    },
                    // 修改试卷/课件时间及限制
                    "/pub_time_limit/:id/:type":{
                        name:"pub_time_limit",
                        component: function (resolve) {
                            require(['module/course/normalcourse/teacher/pre_publish/pub_time_limit.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    },
                    // 新增课程限制页
                    "/set_courselimit/:courseid/:classroomid":{
                        name:"set_courselimit",
                        component: function (resolve) {
                            require(['module/course/normalcourse/logs/set_courselimit.vue'], resolve)
                        }
                    },
                    // 搜索学生
                    "/search/:lessonid/:classroomid": {
                        name: 'search',
                        component: function(resolve){
                            require(['module/course/normalcourse/teacher/search_student.vue'], resolve)
                        }
                    },
                    // 本期暂不支持课下修改学生表现分数&标签
                    '/stuexpression/:classroomid/:lessonid/:userid': {
                        name: 'stuexpression',
                        component: function(resolve){
                            require(['module/course/normalcourse/teacher/student_expression.vue'], resolve)
                        }
                    },
                    '/course_setting/:courseid': {
                        name: 'course_setting',
                        component: function(resolve){
                            require(['module/course/normalcourse/course_setting.vue'], resolve)
                        }
                    },
                    '/course_setting_info/:courseid': {
                        name: 'course_setting_info',
                        component: function(resolve){
                            require(['module/course/normalcourse/course_setting_info.vue'], resolve)
                        }
                    },
                    '/examcover/:cid/:eid': {
                        name: 'exam_cover',
                        component: function(resolve){
                            require(['module/course/normalcourse/student/exam_cover.vue'],resolve)
                        }
                    },
                    '/batch_detail/:coursewareid/:role': {
                        name: 'batchdetail',
                        component: function(resolve){
                            require(['module/course/normalcourse/logs/batch_detail.vue'], resolve)
                        },
                        meta: {
                            reportCid: true
                        }
                    }
                }
            },
            /* 去掉公开课
            '/opencourse': {
                name: 'opencourse',
                component: function (resolve) {
                    require(['module/course/opencourse/opencourse.vue'], resolve)
                },
                subRoutes: {
                    '/': {
                        name: 'opencourse-list',
                        component: function (resolve) {
                            require(['module/course/opencourse/opencourse-list.vue'], resolve)
                        }
                    },
                    '/item/:id': {
                        name: 'opencourse-item',
                        component: function (resolve) {
                            require(['module/course/opencourse/opencourse-item-root.vue'], resolve)
                        },
                        subRoutes: {
                            '/': {
                                component: function (resolve) {
                                    require(['module/course/opencourse/opencourse-item.vue'], resolve)
                                }
                            },
                            '/learningplan': {
                                name: 'opencourse-item-learningplan',
                                component: function (resolve) {
                                    require(['module/course/opencourse/opencourse_item/learningplan.vue'], resolve)
                                }
                            },
                            '/learningplan-purchase': {
                                name: 'opencourse-item-learningplan-purchase',
                                component: function (resolve) {
                                    require(['module/course/opencourse/opencourse_item/learningplan-purchase.vue'], resolve)
                                }
                            },
                            '/learningplan-diff/:from': {
                                name: 'opencourse-item-learningplan-diff',
                                component: function (resolve) {
                                    require(['module/course/opencourse/opencourse_item/learningplan-diff.vue'], resolve)
                                }
                            },
                            '/learning': {
                                name: 'opencourse-item-learning',
                                component: function (resolve) {
                                    require(['module/course/opencourse/opencourse_item/learning.vue'], resolve)
                                }
                            },
                            '/learningcards': {
                                name: 'opencourse-item-learningcards',
                                component: function (resolve) {
                                    require(['module/course/opencourse/opencourse_item/learningcards/learningcards.vue'], resolve)
                                }
                            },
                            '/aboutcourse': {
                                name: 'opencourse-item-aboutcourse',
                                component: function (resolve) {
                                    require(['module/course/opencourse/opencourse_item/aboutcourse.vue'], resolve)
                                }
                            },
                            '/ask': {
                                name: 'opencourse-item-ask',
                                component: function (resolve) {
                                    require(['module/course/opencourse/opencourse_item/ask.vue'], resolve)
                                }
                            },
                            '/qaitem/:itemid': {
                                name: 'opencourse-item-qaitem',
                                component: function (resolve) {
                                    require(['module/course/opencourse/opencourse_item/qaitem.vue'], resolve)
                                }
                            },
                            '/qaitem-single-answer/:answerid': {//我的回答、我收藏的回答页面，只有一条回答
                                name: 'opencourse-item-qaitem-single-answer',
                                component: function (resolve) {
                                    require(['module/course/opencourse/opencourse_item/qaitem-single-answer.vue'], resolve)
                                }
                            },
                            '/qaitem/:itemid/answer': {
                                name: 'opencourse-item-qaitem-answer',
                                component: function (resolve) {
                                    require(['module/course/opencourse/opencourse_item/qaitem-answer.vue'], resolve)
                                }
                            }
                        }
                    }
                }
            },
            */
            '/openplatform':{
                name:'',
                component: function (resolve) {
                    require(['module/course/openplatform/index.vue'], resolve)
                },
                subRoutes:{
                    "/teacher_sydetail/:courseware_id/:classroom_id/:activityid/:userRole":{
                        name:"teacher_sydetail",
                        component: function (resolve) {
                            require(['module/course/openplatform/teacher_sydetail.vue'], resolve)
                        }
                    },
                    "/teacher_complete/:courseware_id/:classroom_id":{
                        name:"teacher_sy_completedetail",
                        component: function (resolve) {
                            require(['module/course/openplatform/teacher_completedetail.vue'], resolve)
                        }
                    },
                    "/teacher_doing/:courseware_id/:classroom_id":{
                        name:"teacher_sy_doingdetail",
                        component: function (resolve) {
                            require(['module/course/openplatform/teacher_doingdetail.vue'], resolve)
                        }
                    },
                    "/teacher_nostart/:courseware_id/:classroom_id":{
                        name:"teacher_sy_nostartdetail",
                        component: function (resolve) {
                            require(['module/course/openplatform/teacher_nostartdetail.vue'], resolve)
                        }
                    },
                    "/teacher_syreport/:courseware_id/:student_id":{
                        name:"teacher_syreport",
                        component: function (resolve) {
                            require(['module/course/openplatform/teacher_syreport.vue'], resolve)
                        }
                    },
                    "/student_sydetail/:courseware_id/:classroom_id":{
                        name:"student_sydetail",
                        component: function (resolve) {
                            require(['module/course/openplatform/student_sydetail.vue'], resolve)
                        }
                    },
                    "/syinfo/:courseware_id/":{
                        name:"syinfo",
                        component: function (resolve) {
                            require(['module/course/openplatform/student_syinfo.vue'], resolve)
                        }
                    },
                }
            }
        }
    },

    // 升级版教师小结
    '/teacher_v3': {
        name: 'teacher_summary_index',
        component(resolve) {
            require(['module/course/teacher/index.vue'], resolve)
        },
        subRoutes: {
            '/teaching_lesson_detail/:lessonid': {
                name: 'teaching_lesson_detail_v3',
                component(resolve) {
                    require(['module/course/teacher/summary.vue'], resolve)
                },
            },
            // 课堂签到统计及学生得分情况
            "/teacher_sign_list_lesson_summary/:lessonid":{
                name:"teacher_sign_list_lesson_summary_v3",
                component(resolve) {
                    require(['module/course/teacher/sign_list.vue'], resolve)
                }
            },
            // 单个学生的签到及得分情况
            "/lesson_summary/:lessonid/:userid":{
                name:"lesson_summary_personal_v3",
                component(resolve) {
                    require(['module/course/teacher/single_sign.vue'], resolve)
                }
            },
            // ppt、习题等列表
            "/show_teacher_ppt/:presentation_id/:lesson_id":{
                name:"show_teacher_ppt_v3",
                component(resolve) {
                    require(['module/course/teacher/ppt_list.vue'], resolve)
                }
            },
            // 单个ppt、习题
            "/show_teacherslide_info/:lessonSlide_id/:currentIndex/:lessonid/:type/:presentation_id":{
                name:"show_teacherslide_info_v3",
                component(resolve) {
                    require(['module/course/teacher/ppt.vue'], resolve)
                }
            },
            // 主观题批改列表
            "/teacher_lesson_subjective_problem_result_list/:lesson_id/:problem_id":{
                name:"teacher_lesson_subjective_problem_result_list_v3",
                component(resolve) {
                    require(['module/course/teacher/subjective_result_list.vue'], resolve)
                }
            },
            // 查看客观题详情
            "/teacher_objective_detail/:lesson_id/:problem_id": {
                name:"teacher_objective_detail_v3",
                component: function (resolve) {
                    require(['module/course/teacher/check_objective_detail.vue'], resolve)
                }
            },
            // 手动批改填空题
            '/blanks/answermark/:user_id/:problem_id/:classroom_id/:scenes_type': {
                name: 'blanks-answer-mark_v3',
                component: function (resolve) {
                    require(['module/course/teacher/blanks-answer-mark.vue'], resolve)
                }
            },
            // 弹幕详情
            "/lesson_danmu_detail/:lesson_id":{
                name:"lesson_danmu_detail_v3",
                component: function (resolve) {
                    require(['module/course/teacher/teacher_summary_danmu_detail.vue'], resolve)
                }
            },
            // 课堂投稿
            "/teacher_tougao/:lessonid":{
                name:"teacher_look_tougao_v3",
                component: function (resolve) {
                    require(['module/course/teacher/teacher_summary_tougao_detail.vue'], resolve)
                }
            },
            // 随机点名
            "/teacher_sign_list/:lessonid":{
                name:"teacher_sign_list_v3",
                component: function (resolve) {
                    require(['module/course/teacher/teacher_summary_rollcall.vue'], resolve)
                }
            },
            // 搜索
            // 搜索学生
            "/search/:lessonid/:classroomid": {
                name: 'search_v3',
                component: function(resolve){
                    require(['module/course/teacher/search.vue'], resolve)
                }
            },
            // 选择课后学生可查看课件范围
            "/select_part_ppt/:type": {
                name: 'select_part_ppt',
                component: function(resolve){
                    require(['module/course/teacher/select_part_ppt.vue'], resolve)
                }
            },
        }
    },
    // 升级版学生小结

    /*--------------------*\
    $  升级版学生小结开始
    \*--------------------*/

    // 主页
    "/learning_lesson_detail_v3/:courseware_id":{
        name:"learning_lesson_detail_v3",
        component: function (resolve) {
            require(['module/course/student/learning_lesson_detail_v3.vue'], resolve)
        }
    },

    // k12所有的推送中转页
    "/k12_loading_page":{
      name:"k12_loading_page",
      component: function (resolve) {
          require(['module/k12/loading_page.vue'], resolve)
      }
    },
    // k12  h5底部菜单的view类型点击后的中转页
    "/k12_view_loading_page":{
      name:"k12_view_loading_page",
      component: function (resolve) {
          require(['module/k12/view_loading_page.vue'], resolve)
      }
    },
    // k12所有的推送中转页/点击底部菜单的中转页，请求接口后的err页面，用于提示用户：无权限/账号未激活/此孩子不是该家长下的孩子等等
    "/k12_err_page":{
      name:"k12_err_page",
      component: function (resolve) {
          require(['module/k12/err_page.vue'], resolve)
      }
    },

    // 不懂 收藏
    "/student_ppt_swipe_v3/:type/:courseware_id/:index/:presentation_id":{
        name:"student_ppt_swipe_v3",
        component: function (resolve) {
            require(['module/course/student/student_ppt_swipe.vue'], resolve)
        }
    },

    // 学生ppt
    "/student_ppt_v3/:presentation_id/:courseware_id/:activity_id/:classroom_id":{
        name:"student_ppt_v3",
        component: function (resolve) {
            require(['module/course/student/student_PPT_v3.vue'], resolve)
        }
    },
     // 截图分享
     '/screenshot_v3/:lessonid': {
        name: 'screenshot_v3',
        component: function (resolve) {
            require(['module/course/student/screenshot_v3.vue'], resolve)
        }
    },
    // 投稿
    "/learning_contribution_v3/:courseware_id":{
        name:"learning_contribution_v3",
        component: function (resolve) {
            require(['module/course/student/look_tougao_v3.vue'], resolve)
        }
    },
    /*--------------------*\
    $  升级版学生小结结束
    \*--------------------*/
    // 主页
    //没有导航菜单的课程相关功能
    //讨论区相关
    '/discussion':{
        name:'root',
        component: function (resolve) {
            require(['module/discussion/root.vue'], resolve)
        },
        subRoutes:{
            "/:classroom_id": {
                name:"discussion",
                component: function (resolve) {
                    require(['module/discussion/index.vue'], resolve)
                }
            },
            "/edit_discussion/:classroom_id/:topic_id": {
                name:"edit_discussion",
                component: function (resolve) {
                    require(['module/discussion/edit_discussion.vue'], resolve)
                }
            },
            "/new_discussion/:classroom_id": {
                name:"new_discussion",
                component: function (resolve) {
                    require(['module/discussion/edit_discussion.vue'], resolve)
                }
            },
            "/info/:classroom_id/:id": {
                name:"discussion_info",
                component: function (resolve) {
                    require(['module/discussion/discussion.vue'], resolve)
                }
            },
            "/info_courseware/:classroom_id/:id": {
                name:"discussion_info_courseware",
                component: function (resolve) {
                    require(['module/discussion-courseware/discussion.vue'], resolve)
                }
            },
            "/comment/:id": {
                name:"discussion_comment",
                component: function (resolve) {
                    require(['module/discussion/comment.vue'], resolve)
                }
            },
            "/comment_courseware/:id/:classroom_id": {
                name:"discussion_comment_courseware",
                component: function (resolve) {
                    require(['module/discussion-courseware/comment.vue'], resolve)
                }
            }
        }
    },

    '/course_v':{
        name: 'course_v',
        component: function (resolve) {
            require(['module/course/course_v.vue'], resolve)
        },
        subRoutes: {
            "/publish_notice/:courseid/:classroom_id":{
                name:"publish_notice",
                component: function (resolve) {
                    require(['module/course/normalcourse/teacher/publish_notice.vue'], resolve)
                }
            },
            "/notice_view/:courseware_id/":{
                name:"notice_view",
                component: function (resolve) {
                    require(['module/course/normalcourse/notice_view.vue'], resolve)
                }
            },
            "/notice_notice_up/:courseware_id/":{
                name:"notice_notice_up",
                component: function (resolve) {
                    require(['module/course/normalcourse/notice_notice_up.vue'], resolve)
                }
            },
            "/notice_view_new":{
                name:"notice_view_new",
                component: function (resolve) {
                    require(['module/course/normalcourse/notice_view_new.vue'], resolve)
                }
            },
            "/notice_ready_static/:courseware_id":{
                name:"notice_ready_static",
                component: function (resolve) {
                    require(['module/course/normalcourse/teacher/notice_ready_static.vue'], resolve)
                }
            }
        }
    },
    '/my_collections': {
        name: 'my_collections',
        component: function (resolve) {
            require(['module/mycollections/mycollections_folder.vue'], resolve)
        }
    },
    '/my_collections2': {
        name: 'my_collections2',
        component: function (resolve) {
            require(['module/mycollections/mycollections.vue'], resolve)
        }
    },
    '/manage_collections': {
        name: 'manage_collections',
        component: function (resolve) {
            require(['module/mycollections/managecollections.vue'], resolve)
        }
    },
    '/my_collections_moving/:type': {
        name: 'my_collections_moving',
            component: function (resolve) {
            require(['module/mycollections/moving.vue'], resolve)
        }
    },
    '/my_collections_movetofolder/:pagetype': {
        name: 'my_collections_movetofolder',
        component: function (resolve) {
            require(['module/mycollections/moveToFolder.vue'], resolve)
        }
    },
    '/my_collections_tofolder/:pagetype': {
        name: 'my_collections_tofolder',
        component: function (resolve) {
            require(['module/mycollections/folder_expand.vue'], resolve)
        }
    },
    '/my_collections_research/:pagetype': {
        name: 'my_collections_research',
        component: function (resolve) {
            require(['module/mycollections/mycollections_research.vue'], resolve)
        }
    },
    '/my_papers': {
        name: 'my_papers',
        component: function (resolve) {
            //require(['module/mypapers/mypapers.vue'], resolve)
            require(['module/mycollections/mycollections_folder.vue'], resolve)
        }
    },
    '/my_papers_moving/:type': {
        name: 'my_papers_moving',
        component: function (resolve) {
            require(['module/mycollections/moving.vue'], resolve)
        }
    },
    '/manage_papers': {
        name: 'manage_papers',
        component: function (resolve) {
            require(['module/mypapers/managepapers.vue'], resolve)
        }
    },

    '/discover': {
        name: 'discover',
        component: function (resolve) {
            require(['module/discover/discover.vue'], resolve)
        },
        subRoutes: {
            '/': {
                name: 'discover-index',
                component: function (resolve) {
                    require(['module/discover/discover-index.vue'], resolve)
                }
            }
        }
    },
    '/message': {
        name: 'message',
        component: function (resolve) {
            require(['module/message/messagelist.vue'], resolve)
        }
    },

    //协同教师被移除或添加的提示页面
    "collaborator_msg": {
        name:'collaborator_msg',
        component: function (resolve) {
            require(['module/message/collaborator.vue'], resolve)
        }
    },
    // 学情预警消息提醒
    "academicWarnning": {
        name:'academicWarnning',
        component: function (resolve) {
            require(['module/message/academicWarnning.vue'], resolve)
        }
    },
    '/myself': {
        name: 'myself',
        component: function (resolve) {
            require(['module/myself/myself.vue'], resolve)
        }
    },
    '/edituserinfo_simple': {
        name: 'edituserinfo_simple',
        component: function (resolve) {
            require(['module/myself/edituserinfo_simple.vue'], resolve)
        }
    },
    '/myself_edit': {
        name: 'myself_edit',
        component: function (resolve) {
            require(['module/myself/myselfedit.vue'], resolve)
        }
    },
    '/mymainpage': {
        name: 'mymainpage',
        component: function (resolve) {
            require(['module/mystore/mymainpage.vue'], resolve)
        }
      },
    '/bindSchool_list': {
      name: 'bindSchool_list',
      component: function (resolve) {
        // require(['module/mystore/bindSchool_list.vue'], resolve)
        require(['module/mystore/bindSchool_list_new.vue'], resolve)
      }
    },
    '/hasbindschool': {
        name: 'hasbindschool',
        component: function (resolve) {
            require(['module/mystore/hasbindschool.vue'], resolve)
        }
    },
    '/bindschool_register/:id': {
        name: 'bindschool_register',
        component: function (resolve) {
            require(['module/mystore/bindSchool_register.vue'], resolve)
        }
    },
    '/bindschool_tips': {
        name: 'bindschool_tips',
        component: function (resolve) {
            require(['module/mystore/other_env_tips.vue'], resolve)
        }
    },
    // 一体化特殊学校的绑定 special_binding
    '/special_binding/:id': {
        name: 'special_binding',
        component: function (resolve) {
            require(['module/mystore/special_binding.vue'], resolve)
        }
    },
    /*设置新增*/
    '/setting': {
      name: 'setting',
      component: function (resolve) {
        require(['module/mystore/setting.vue'], resolve)
      }
    },
    '/setting_lang': {
      name: 'setting_lang',
      component: function (resolve) {
        require(['module/mystore/setting_lang.vue'], resolve)
      }
    },
    '/identityBinding/:code': {
        name: 'identityBinding',
        component: function (resolve) {
            require(['module/mystore/identityBinding.vue'], resolve)
        }
    },
    '/bindSchool/:school_id': {
      name: 'bindSchool',
      component: function (resolve) {
        require(['module/mystore/bindSchool_new.vue'], resolve)
      }
    },
    '/cas_confirm/:school_id': {
      name: 'cas_confirm',
      component: function (resolve) {
        require(['module/mystore/cas_confirm.vue'], resolve)
      }
    },
    '/bindSchool_validate/:school_id': {
        name: 'bindSchool_validateCode',
        component: function (resolve) {
            require(['module/mystore/bindSchool_validateCode.vue'], resolve)
        }
    },
    '/bindSchool_unlock/:school_id': {
      name: 'bindSchool_unlock',
      component: function (resolve) {
        require(['module/mystore/bindSchool_unlock.vue'], resolve)
      }
    },
    '/bindSchool_fail': {
        name: 'bindSchool_fail',
        component: function (resolve) {
            require(['module/mystore/bindSchool_fail.vue'], resolve)
        }
    },
    '/bindGuidance': {
        name: 'bindGuidance',
        component: function (resolve) {
            require(['module/mystore/bindGuidance.vue'], resolve)
        }
    },
    '/bindSchool_cas/:school_id': {
        name: 'bindSchoolCas',
        component: function(resolve){
            require(['module/mystore/bindSchool_cas.vue'], resolve)
        }
    },
    '/bind_page': {
        name: 'bindPage',
        component: function(resolve){
            require(['module/mystore/go-bind-page.vue'], resolve)
        }
    },
    // k12需要绑定页面
    '/need-bind': {
      name: 'needBind',
      component: function (resolve) {
        require(['module/mystore/need-bind.vue'], resolve)
      }
    },
    // k12选择身份
    '/choose-identity/:school_id': {
      name: 'chooseIdentity',
      component: function (resolve) {
        require(['module/mystore/choose-identity.vue'], resolve)
      }
    },
    // k12身份绑定 - 输入账号+密码
    '/k12-bind-identity/:school_id/:identity': {
      name: 'k12BindIdentity',
      component: function (resolve) {
        require(['module/mystore/k12-bind-identity.vue'], resolve)
      }
    },
    // k12身份绑定 - 输入校内姓名
    '/k12-verify-name/:school_id': {
      name: 'k12VerifyName',
      component: function (resolve) {
        require(['module/mystore/k12-verify-name.vue'], resolve)
      }
    },
    // k12第一步 绑定孩子 - 输入姓名+账号+密码+身份
    '/k12-bind-child/:school_id': {
      name: 'bindChild',
      component: function (resolve) {
        require(['module/mystore/k12-bind-child.vue'], resolve)
      }
    },
    // k12第一步 注册账号 - 输入手机号+验证码+密码
    '/k12-register-account/:school_id': {
      name: 'k12RegisterAccount',
      component: function (resolve) {
        require(['module/mystore/k12-register-account.vue'], resolve)
      }
    },
    '/taaAuth': {
        name: 'taaAuth',
        component: function(resolve){
            require(['module/mystore/taaAuth.vue'], resolve)
        }
    },
    '/bank': {
        name: 'bank-root',
        component: function (resolve) {
            require(['module/myself/bank/bank-root.vue'], resolve)
        },
        subRoutes: {
            "/":{
                name:'bank',
                component: function (resolve) {
                    require(['module/myself/bank/bank.vue'], resolve)
                }
            },
            "/:userId":{
                name:'bank',
                component: function (resolve) {
                    require(['module/myself/bank/bank.vue'], resolve)
                }
            },
            "/recharge":{
                name:'bank-recharge',
                component: function (resolve) {
                    require(['module/myself/bank/bank-recharge.vue'], resolve)
                }
            },
            "/withdraw/:userId":{
                name:'bank-withdraw',
                component: function (resolve) {
                    require(['module/myself/bank/bank-withdraw.vue'], resolve)
                }
            },
            "/bill":{
                name:'bank-bill',
                component: function (resolve) {
                    require(['module/myself/bank/bank-bill.vue'], resolve)
                }
            }
        }
    },

    // 习题集
    '/problem_sets': {
        name: 'problem_sets_root',
        component: function (resolve) {
            require(['module/myself/problemsets/problemsets-root.vue'], resolve)
        },
        subRoutes: {
            "/":{
                name:'problem_sets',
                component: function (resolve) {
                    require(['module/myself/problemsets/problemsets.vue'], resolve)
                }
            },
            "/course/:classroomid":{
                name:'problem_sets_course',
                component: function (resolve) {
                    require(['module/myself/problemsets/problemsets-course.vue'], resolve)
                }
            },
            "/problem/:id/:problemid":{
                name:'problem_sets_problem',
                component: function (resolve) {
                    require(['module/myself/problemsets/problem.vue'], resolve)
                },
                subRoutes: {
                    "/answer/:index":{
                        name:'problem_answer',
                        component: function (resolve) {
                           require(['module/myself/problemsets/answer.vue'], resolve)
                        }
                    },
                    "/subjective/:index":{
                        name:'problem_subjective',
                        component: function (resolve) {
                           require(['module/myself/problemsets/answer-subjective.vue'], resolve)
                        }
                    },
                    "/redo/:index":{
                        name:'problem_redo',
                        component: function (resolve) {
                           require(['module/myself/problemsets/redo.vue'], resolve)
                        }
                    },
                    "/nodes/:index":{
                        name:'problem_nodes',
                        component: function (resolve) {
                           require(['module/myself/problemsets/notes.vue'], resolve)
                        }
                    },
                    "/blanks/:id/:type":{
                        name:'problem_blanks',
                        component: function (resolve) {
                           require(['pages/blanks/blanks-answer-detail.vue'], resolve)
                        }
                    },
                }
            }
        }
    },

    // 私信相关设置
    // ta的个人主页
    'homepage/:user_id': {
        name: 'homepage',
        component: function (resolve) {
            require(['module/letter/homepage.vue'], resolve)
        }
    },
    // 私信页面
    'letter/:user_id': {
        name: 'letter',
        component: function (resolve) {
            require(['module/letter/letter.vue'], resolve)
        }
    },

    '/mystore': {
        name: 'mystore',
        component: function (resolve) {
            require(['module/mystore/mystore.vue'], resolve)
        }
    },
    '/mystore_symbol/:pptindex': {
        name: 'mystore_symbol',
        component: function (resolve) {
            require(['module/mystore/mystore_symbol.vue'], resolve)
        }
    },
    // 投稿
    '/mystore_tougao_v3/:tougaoIndex/:listIndex': {
        name: 'mystore_tougao_v3',
        component: function (resolve) {
            require(['module/mystore/tougao_v3.vue'], resolve)
        }
    },
    '/mystore_boards': {
        name: 'mystore_boards',
        component: function (resolve) {
            require(['module/mystore/board-list.vue'], resolve)
        }
    },

    // 填空题统计页
    '/blanks/detail/:type/:id/:cid': {
        name: 'blanks-detail',
        component: function (resolve) {
            require(['pages/blanks/blanks-detail.vue'], resolve)
        }
    },

    '/blanks/lessondetail/:slideid/:lessonid/:presentationid': {
        name: 'blanks-detail-lesson',
        component: function (resolve) {
            require(['pages/blanks/blanks-detail-lesson.vue'], resolve)
        }
    },

    // 填空题做题页制作
    '/blanks/answer/:type/:id/:cid': {
        name: 'blanks-answer',
        component: function (resolve) {
            require(['pages/blanks/blanks-answer.vue'], resolve)
        }
    },

    // 填空题做题结果页制作
    '/blanks/answerresult/:type/:id/:cid': {
        name: 'blanks-answer-result',
        component: function (resolve) {
            require(['pages/blanks/blanks-answer-result.vue'], resolve)
        }
    },
    // 审核行政通知
    '/inform_preview/:id': {
        name: 'inform_preview',
        component: function (resolve) {
            require(['module/inform/inform_preview.vue'], resolve)
        }
    },
    // 兼容query和params两种格式的审核行政通知,为了防止打开以前的推送，先留着吧
    '/inform_preview': {
        name: 'inform_preview',
        component: function (resolve) {
            require(['module/inform/inform_preview.vue'], resolve)
        }
    },
    // 填空题作答详情
    '/blanks/answerdetail/:id/:type': {
        name: 'blanks-answer-detail',
        component: function (resolve) {
            require(['pages/blanks/blanks-answer-detail.vue'], resolve)
        }
    },

    // 手动批改填空题
    '/blanks/answermark/:user_id/:problem_id/:classroom_id/:scenes_type': {
        name: 'blanks-answer-mark',
        component: function (resolve) {
            require(['pages/blanks/blanks-answer-mark.vue'], resolve)
        }
    },

    // 课上回放
    '/playback/:lessonid': {
        name: 'playback',
        component: function (resolve) {
            require(['module/course/normalcourse/student/playback/playback.vue'], resolve)
        }
    },

    // 课上回放 v3接口升级
    '/v3/playback/:lessonid': {
        name: 'playback_v3',
        component: function (resolve) {
            require(['module/course/student/playback/playback.vue'], resolve)
        }
    },

    // 截图分享
    '/screenshot/:lessonid': {
        name: 'screenshot',
        component: function (resolve) {
            require(['module/course/normalcourse/student/screenshot.vue'], resolve)
        }
    },

    // 测试新评论
    '/comment_input': {
        name: 'input-box',
        component: function (resolve) {
            require(['module/discussion/components/comment-input.vue'], resolve)
        }
    },

    // 月报功能
    '/monthly': {
        name: 'monthly',
        component: function (resolve) {
            require(['module/monthly/monthly.vue'], resolve)
        }
    },

    //申请身份认证审核
    '/apply_identify_audit':{
        name: 'apply_identify_audit',
        component:function (resolve) {
            require(['pages/apply_identify_audit/apply_identify_audit.vue'], resolve)
        }
    },
    //申请直博认证审核
    '/apply_live_audit/:course_id/:classroom_id':{
        name: 'apply_live_audit',
        component:function (resolve) {
            require(['pages/apply_live_audit/apply_live_audit.vue'], resolve)
        }
    },
    //申请直博认证结果
    '/apply_live_result/:course_id/:classroom_id':{
        name: 'apply_live_result',
        component:function (resolve) {
            require(['pages/apply_live_audit/apply_live_result.vue'], resolve)
        }
    },
    // 运营人员 ：查看直播审核列表
    '/audit':{
        name:'audit',
        component:function(reslove){
            require(['pages/audit/audit.vue'],reslove)
        },
        subRoutes: {
            //运营人员 ：查看直播审核列表
            '/audit_list':{
                name:'audit_list',
                component:function(reslove){
                    require(['pages/audit/audit_list.vue'],reslove)
                }
            },
            // 运营人员 审核身份证页面
            '/audit_identify/:user_id/:audit_id':{
                name:'audit_identify',
                component:function(reslove){
                    require(['pages/audit/audit_identify.vue'],reslove)
                }
            },
            // 运营人员 审核直播页面
            '/audit_live/:audit_id':{
                name:'audit_live',
                component:function(reslove){
                    require(['pages/audit/audit_live.vue'],reslove)
                }
            },
        }
    },

    // 账号密码设置相关
    '/setting_account': {
        name: 'setting_account',
        component: function(resolve){
            require(['module/mystore/setting_account.vue'], resolve)
        }
    },
    '/setting_email': {
        name: 'setting_email',
        component: function(resolve){
            require(['module/mystore/setting_email.vue'], resolve)
        }
    },
    '/setting_password': {
        name: 'setting_password',
        component: function(resolve){
            require(['module/mystore/setting_password.vue'], resolve)
        }
    },
    'setting_phone': {
        name: 'setting_phone',
        component: function(resolve){
            require(['module/mystore/setting_phone.vue'], resolve)
        }
    },

    // 会员审核页面相关
    '/apply_vip_index': {
        name: 'apply_vip_index',
        component: function(resolve){
            require(['pages/apply_vip_audit/apply_vip_index.vue'], resolve)
        }
    },
    '/apply_vip_audit': {
        name: 'apply_vip_audit',
        component: function(resolve){
            require(['pages/apply_vip_audit/apply_vip_audit.vue'], resolve)
        }
    },
    '/apply_vip_success': {
        name: 'apply_vip_success',
        component: function(resolve){
            require(['pages/apply_vip_audit/apply_vip_success.vue'], resolve)
        }
    },

    // 投票器绑定
    '/voter/binding': {
        name: 'voter_binding',
        component: function (resolve) {
            require(['module/voter/binding.vue'], resolve)
        }
    },
})

router.redirect({
    "/learning_lesson_detail/:courseware_id":"/course/normalcourse/learning_lesson_detail/:courseware_id",
    "/teaching_lesson_detail/:courseware_id":"/course/normalcourse/teaching_lesson_detail/:courseware_id",
    "/error/:status_code":"/course/normalcourse/error/:status_code",
    '*': '/course/normalcourse'
})

router.beforeEach(function (transition){
    window.isHistoryBack = false;
    let fromcourse2course = (transition.to.name == 'course' && transition.from.name == 'normalcourse')
    if(!fromcourse2course){
        $("#global_loading").length == 0 && $(document.body).append("<div id='global_loading' style='display: none;'><img src='https://fe-static-yuketang.yuketang.cn/fe/static/vue_images/2.2.561/images/loading-3.gif'></div>");
        // $("#global_loading").show();
    }

    //当点击进入拥有二级导航的一级导航时，定位到之前已经进入的二级导航
    if(transition.to.name === 'course'){
        let children = navData.navlist[vars.navlv1number.course].children
        let activeindex = localStorage && localStorage.getItem('rain.course.activeindex') || children.activeindex;
        transition.redirect({
            name: children.list[+activeindex].rel
        })
        $("#global_loading").hide();
    }

    if(transition.to.name == 'mystore' && transition.from.name == 'mymainpage' || !transition.from.name){
        window.loadNewCollection = true
    }else {
        window.loadNewCollection = false
    }

    // 订阅发布重置
    let pubSub = window.parent && window.parent.PubSub || null;
    pubSub && pubSub.publish( 'reset', { msg: 'reset', name: transition.to.name } );


    resetNavbar.call(router.app, transition.to.name)

    setDocumentTitle()

    transition.next()


})

router.afterEach(function (transition){
    $("#global_loading").hide();
    // 统计
    setTimeout(()=>{
        if(typeof dailyReport !== 'undefined') {
            if(transition.to.params.classroom_id || transition.to.params.classroomid || transition.to.params.cid || transition.to.query.cid || transition.to.query.classroomid || transition.to.query.classroomID || transition.to.meta && transition.to.meta.reportCid) {
                let key = 'Report.Daily.Cid'
                let cid = transition.to.params.classroom_id || transition.to.params.classroomid || transition.to.params.cid || transition.to.query.cid || transition.to.query.classroomid || transition.to.query.classroomID || window.sessionStorage.getItem(key)
                dailyReport.updateLog({ classroom_id: +cid}, true)
            } else {
                dailyReport.updateLog({ classroom_id: undefined}, true)
            }
        }
        // pv单页面统计
        typeof dailyReport !== 'undefined' && dailyReport.reportLog();
    }, 2000);

    if($.isAndroid() && transition.to.name && transition.to.name.indexOf('opencourse') !== -1) {
        $.setWXConfig();
    }
    setTimeout(()=>{
        // 解决 android手机字体缩放
        setSize();
    }, 1200);

    if((document.title==='雨课堂' || document.title=== 'Rain Classroom') && Vue.prototype.isYD){
        setDocumentTitle()
    }
})

//防止键盘弹出时，挡住录入框
window.addEventListener("resize", function() {
    if(document.activeElement.tagName=="INPUT" || document.activeElement.tagName=="TEXTAREA") {
        window.setTimeout(function() {
            document.activeElement.scrollIntoViewIfNeeded();
        },0);
    }
});

window.addEventListener("popstate", function(e) {
    setTimeout(function(){//回退时添加标记，判断是否需要设置滚动条位置
        window.isHistoryBack = true;
    },0);
});



// 解决 android手机字体缩放
setSize();

// 检测http协议改成https
initProtocal();

pagereload();

// 检测是否在小程序中
typeof wx !== 'undefined' && wx.miniProgram.getEnv(function(res) {
  if(res.miniprogram) {
    window.miniprogram = true;
  }
})

setHeaderStorageFn().then(e => {
    router.start(App, 'app')
}).catch(e=>{
    router.start(App, 'app')
})

function zPrint() {
    let text = "";
    for (let i = 0; i< arguments.length; i++) {
        text += arguments[i]
    }
    text += ";<br/>"
    const zclient = document.querySelector('#zClientPrint')
    if (zclient) {
        zclient.innerHTML += text
    } else {
        let div = document.createElement('div')
        div.id = "zClientPrint"
        div.style.position = "fixed"
        div.style.bottom = "50px"
        div.style.zIndex = 1111111111
        div.style.background = "rgba(122, 64, 72, 0.1)"
        div.style.pointerEvents = "none"
        div.style.fontSize = "14px"
        document.body.append(div)
        div.innerHTML = text
    }
}


setTimeout(() => {
    if(window.__wxjs_environment === 'miniprogram' || (window.parent && window.parent.__wxjs_environment === 'miniprogram')){
        return
    }else {
        let jiguangSrc = 'https://web-stat.jiguang.cn/web-janalytics/scripts/janalytics-web.min.js'
        loadScript(jiguangSrc)
        .then(() => {
            (function() {
                if(window.JAnalyticsInterface) {
                    window.JAnalyticsInterface.init({
                        appkey: 'fcdf8e635093adde6bef4265',
                        debugMode: false,
                        channel: 'rainH5',
                        loc: false, //设置是否尝试获取位置信息上报，默认为 true
                        singlePage: true //设置是否为单页面，默认为 false
                    });
                }
            })();
        })
    }

}, 3000)



// WEBPACK FOOTER //
// ./src/index.js